import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1a580514")

_pushScopeId("data-v-1a580514")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_3 = { class: "page" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Recommended ")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { style: {"margin-top":"10px"} }, [
  /*#__PURE__*/_createVNode("h4", { class: "text-dark" }, "Choose the workouts you prefer")
], -1)
const _hoisted_6 = {
  color: "medium",
  class: "text-sm"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("What intensity do you train at?")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("High Intensity")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Moderate Intensity")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Light")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("How long do you train for?")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Submit")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Fetching your Recommended Classes ")
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: "assets/recommended-loader.gif",
  style: {"opacity":"0.4"}
}, null, -1)
const _hoisted_17 = { class: "video-info" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "text-md" }, " No Classes Match Your Choices, but have a look at some of the featured classes below :) ", -1)
const _hoisted_19 = { class: "video-info" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_fab = _resolveComponent("ion-fab")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_text = _resolveComponent("ion-text")
  const _component_ion_badge = _resolveComponent("ion-badge")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_Navbar)
        ]),
        _: 1
      }),
      (!_ctx.loading && _ctx.classes.length > 0)
        ? (_openBlock(), _createBlock(_component_ion_fab, {
            key: 0,
            vertical: "bottom",
            horizontal: "center",
            class: ["centerme", { marginbottom: !_ctx.isWeb }]
          }, {
            default: _withId(() => [
              (!_ctx.toggleFilter)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    color: "light",
                    shape: "round",
                    onClick: _cache[1] || (_cache[1] = () => _ctx.openFilterModal())
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        size: "small",
                        icon: _ctx.filterCircleOutline,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _hoisted_1
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.toggleFilter)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    color: "primary",
                    shape: "round",
                    onClick: _cache[2] || (_cache[2] = () => _ctx.openFilterModal())
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        size: "small",
                        icon: _ctx.filterCircleOutline,
                        slot: "start"
                      }, null, 8, ["icon"]),
                      _hoisted_2
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true),
      (!_ctx.classesLoading)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 1,
            fullscreen: true
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_ion_grid, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, { style: {"display":"flex","justify-content":"space-between"} }, {
                          default: _withId(() => [
                            _hoisted_4,
                            _createVNode(_component_ion_icon, {
                              onClick: _ctx.resubmitQuestionaire,
                              icon: _ctx.reloadOutline
                            }, null, 8, ["onClick", "icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            (
									_ctx.visibleSection === 0 &&
									!_ctx.userProfile.classPreferences?.duration &&
									!_ctx.userProfile.classPreferences?.category &&
									!_ctx.loading
								)
                              ? (_openBlock(), _createBlock(_component_ion_card, {
                                  key: 0,
                                  class: "recommended-card"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5,
                                    _createVNode(_component_ion_grid, null, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_row, null, {
                                          default: _withId(() => [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                                              return (_openBlock(), _createBlock(_component_ion_col, {
                                                sizeLg: "3",
                                                sizeSm: "12",
                                                size: "12",
                                                key: index
                                              }, {
                                                default: _withId(() => [
                                                  _createVNode(_component_ion_item, {
                                                    color: "light",
                                                    s: ""
                                                  }, {
                                                    default: _withId(() => [
                                                      _createVNode(_component_ion_label, null, {
                                                        default: _withId(() => [
                                                          _createVNode("span", _hoisted_6, _toDisplayString(category.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_component_ion_checkbox, {
                                                        color: "primary",
                                                        "v-model": _ctx.checkedCategory[index],
                                                        onClick: ($event: any) => (_ctx.selectCategory(index))
                                                      }, null, 8, ["v-model", "onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_row, null, {
                                          default: _withId(() => [
                                            _createVNode(_component_ion_col, null, {
                                              default: _withId(() => [
                                                _createVNode(_component_ion_button, {
                                                  color: "primary",
                                                  size: "block",
                                                  onClick: _ctx.selectVisible
                                                }, {
                                                  default: _withId(() => [
                                                    _hoisted_7
                                                  ]),
                                                  _: 1
                                                }, 8, ["onClick"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (
									_ctx.visibleSection === 4 &&
									!_ctx.userProfile.classPreferences?.duration &&
									!_ctx.userProfile.classPreferences?.category &&
									!_ctx.loading
								)
                              ? (_openBlock(), _createBlock(_component_ion_card, {
                                  key: 1,
                                  class: "recommended-card"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_text, null, {
                                      default: _withId(() => [
                                        _hoisted_8
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, { color: "light" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_checkbox, {
                                          color: "primary",
                                          slot: "start"
                                        }),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withId(() => [
                                            _hoisted_9
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, { color: "light" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_checkbox, {
                                          color: "primary",
                                          slot: "start"
                                        }),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withId(() => [
                                            _hoisted_10
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_item, { color: "light" }, {
                                      default: _withId(() => [
                                        _createVNode(_component_ion_checkbox, {
                                          color: "primary",
                                          slot: "start"
                                        }),
                                        _createVNode(_component_ion_label, null, {
                                          default: _withId(() => [
                                            _hoisted_11
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_button, {
                                      color: "primary",
                                      size: "block",
                                      onClick: _ctx.selectVisible
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_12
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (
									_ctx.visibleSection === 1 &&
									!_ctx.userProfile.classPreferences?.duration &&
									!_ctx.userProfile.classPreferences?.category &&
									!_ctx.loading
								)
                              ? (_openBlock(), _createBlock(_component_ion_card, {
                                  key: 2,
                                  class: "recommended-card"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_text, null, {
                                      default: _withId(() => [
                                        _hoisted_13
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.durations, (duration, index) => {
                                      return (_openBlock(), _createBlock(_component_ion_item, {
                                        color: "light",
                                        key: index
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_checkbox, {
                                            color: "primary",
                                            slot: "start",
                                            onClick: ($event: any) => (_ctx.selectDuration(index))
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withId(() => [
                                              _createTextVNode(_toDisplayString(duration) + " Minutes", 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128)),
                                    _createVNode(_component_ion_button, {
                                      color: "primary",
                                      size: "block",
                                      onClick: _ctx.submitQuestionaire
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_14
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.loading)
                              ? (_openBlock(), _createBlock(_component_ion_card, {
                                  key: 3,
                                  class: "recommended-card"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ion_item, { color: "light" }, {
                                      default: _withId(() => [
                                        _hoisted_15
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_16
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (!_ctx.loading && _ctx.classes.length > 0)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredClasses, (classObject, index) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                size: "12",
                                "size-lg": "4",
                                "size-md": "4",
                                "size-sm": "12",
                                key: index
                              }, {
                                default: _withId(() => [
                                  (_ctx.isBookmarked(classObject))
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        class: "bookmarkBtn",
                                        fill: "clear",
                                        onClick: ($event: any) => (_ctx.removeBookmark(classObject))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_icon, {
                                            icon: _ctx.bookmark,
                                            color: "light"
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 1,
                                        class: "bookmarkBtn",
                                        fill: "clear",
                                        onClick: ($event: any) => (_ctx.addBookmark(classObject))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_icon, {
                                            color: "light",
                                            icon: _ctx.bookmarkOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])),
                                  _createVNode(_component_ion_card, {
                                    class: "category-card",
                                    button: "",
                                    onClick: ($event: any) => (_ctx.openModal(classObject))
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_badge, {
                                        color: "primary",
                                        class: "class-badge"
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(classObject.isLive ? "LIVE" : "On Demand"), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_ion_img, {
                                        src: classObject?.imgURL
                                      }, null, 8, ["src"]),
                                      _createVNode("div", _hoisted_17, [
                                        _createVNode("h5", null, _toDisplayString(classObject?.name), 1),
                                        _createTextVNode(" " + _toDisplayString(classObject?.trainerData.name) + " ", 1),
                                        (_ctx.hasProgressed(classObject))
                                          ? (_openBlock(), _createBlock(_component_ion_badge, {
                                              key: 0,
                                              color: "dark",
                                              class: "class-watched"
                                            }, {
                                              default: _withId(() => [
                                                _createTextVNode(_toDisplayString(_ctx.progressType(classObject.classID)), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && _ctx.classes.length === 0 && _ctx.visibleSection > 4)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_card, null, {
                              default: _withId(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && _ctx.classes.length === 0 && _ctx.visibleSection > 4)
                      ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.featured, (classObject, index) => {
                              return (_openBlock(), _createBlock(_component_ion_col, {
                                size: "12",
                                "size-lg": "4",
                                "size-md": "4",
                                "size-sm": "12",
                                key: index
                              }, {
                                default: _withId(() => [
                                  (_ctx.isBookmarked(classObject))
                                    ? (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 0,
                                        class: "bookmarkBtn",
                                        fill: "clear",
                                        onClick: ($event: any) => (_ctx.removeBookmark(classObject))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_icon, {
                                            icon: _ctx.bookmark,
                                            color: "light"
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_ion_button, {
                                        key: 1,
                                        class: "bookmarkBtn",
                                        fill: "clear",
                                        onClick: ($event: any) => (_ctx.addBookmark(classObject))
                                      }, {
                                        default: _withId(() => [
                                          _createVNode(_component_ion_icon, {
                                            color: "light",
                                            icon: _ctx.bookmarkOutline
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])),
                                  _createVNode(_component_ion_card, {
                                    class: "category-card",
                                    button: "",
                                    onClick: ($event: any) => (_ctx.openModal(classObject)),
                                    style: {
									'background-image': 'url(' + classObject?.imgURL + ')',
								}
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_badge, {
                                        color: "primary",
                                        class: "class-badge"
                                      }, {
                                        default: _withId(() => [
                                          _createTextVNode(_toDisplayString(classObject.isLive ? "LIVE" : "On Demand"), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode("div", _hoisted_19, [
                                        _createVNode("h5", null, _toDisplayString(classObject?.name), 1),
                                        _createTextVNode(" " + _toDisplayString(classObject?.trainerData.name) + " ", 1),
                                        (_ctx.hasProgressed(classObject))
                                          ? (_openBlock(), _createBlock(_component_ion_badge, {
                                              key: 0,
                                              color: "dark",
                                              class: "class-watched"
                                            }, {
                                              default: _withId(() => [
                                                _createTextVNode(_toDisplayString(_ctx.progressType(classObject.classID)), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "style"])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_ion_content, {
            key: 2,
            fullscreen: true,
            class: "ion-text-center"
          }, {
            default: _withId(() => [
              _createVNode(_component_ion_spinner, { name: "crescent" })
            ]),
            _: 1
          })),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})